<template>
  <div class="w-full bg-pink-100 p-3 text-center font-medium text-white">
    <slot></slot>
  </div>
</template>
